import { styled } from '@mui/material';
import { Grid } from '@mui/system';
import { Dialog } from 'components/Dialogs';

// Styled components
export const StyledActionButtonsGrid = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paperWidthSm': {
    maxWidth: '700px !important',
  },
}));
